export default __webpack_public_path__ + "static/media/mebloscianki1.71ee10fd.jpg";